module.exports = "/_next/static/images/dailyevent-8cb1dc737aa67c417bbab51b953222c9.jpg";